
<template>
<div id="empresas">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="domain" title="Administrar Empresas" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer />

            <v-btn fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <v-dialog v-model="modal" max-width="60%">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ tituloModal }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="formempresa">
                      <v-card width="100%">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field v-model="model.nombre" label="Nombre" :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-text-field v-model="model.telefono" label="Teléfono" :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-text-field v-model="model.email" label="Email" :rules="[rules.required, rules.email]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-autocomplete v-model="model.estatus" :items="estatus" :hide-no-data="true" item-text="estatus" item-value="estatus" label="Seleccione un Estatus" :rules="[rules.required]">
                              </v-autocomplete>
                            </v-col>
                            <v-col>
                              <v-switch v-model="model.prepago" label="¿Prepago?"></v-switch>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <br>
                      <v-card width="100%">
                        <v-subheader>Contacto:</v-subheader>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="4" md="4">
                              <v-text-field v-model="model.contacto.nombre" label="Nombre" :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-text-field v-model="model.contacto.telefono" label="Teléfono" :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-text-field v-model="model.contacto.email" label="Email" :rules="[rules.required, rules.email]"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>

                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="default" small @click="modal=false">
                    <v-icon small>mdi-cancel</v-icon> Cancelar
                  </v-btn>
                  <v-btn color="success" small @click="guardar">
                    <v-icon small>mdi-check-circle-outline</v-icon> Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
              <template slot="noResults">
                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
              </template>
              <template slot="actions" slot-scope="props">
                <v-btn fab color="success" x-small title="Editar Registro" @click="editar(props.row.uuid)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn fab color="error" x-small title="Eliminar Registro" @click="eliminar(props.row.uuid)">
                  <v-icon small>mdi-trash-can</v-icon>
                </v-btn>

                <v-btn fab color="warning" x-small title="Pagos" @click="pagos(props.row.uuid)">
                  <v-icon small>mdi-currency-usd</v-icon>
                </v-btn>
              </template>
            </v-client-table>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>

  <v-dialog v-model="modal_pagos" max-width="60%">
    <v-card>
      <v-card-title>
        <span class="headline">Pagos de la Empresa</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form_pagos">
            <v-card width="100%">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3" md="3">
                    <v-text-field v-model="model_pagos.importe" label="Importe" :rules="[rules.required, rules.decimal]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-text-field v-model="model_pagos.creditos" label="Créditos" :rules="[rules.required, rules.entero]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-btn fab dark x-small color="success" slot="activator" @click.native="guardar_pago" title="Agregar Pago" v-tippy>
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-client-table ref="vuetable" :data="items_pagos" :columns="columns_pagos" :options="options_pagos" class="elevation-2 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>
                  <template slot="actions" slot-scope="props">
                    <v-btn fab color="error" x-small title="Eliminar Registro" @click="eliminar_pago(props.row.uuid)">
                      <v-icon small>mdi-trash-can</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </v-card-text>
            </v-card>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" small @click="modal_pagos=false">
          <v-icon small>mdi-cancel</v-icon> Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>



<script>
import moment from "moment";
export default {
  name: "DashboardDataTables",

  data: () => ({
    URL: "",
    tabla: "empresas",
    modal: false,
    modal_pagos: false,
    usuario: "",
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Empresas",
        disabled: true,
        href: "",
      },
    ],
    estatus: [{
      "estatus": "Activo"
    }, {
      "estatus": "Inactivo"
    }],
    model_pagos: {},
    model: {
      uuid: "",
      nombre: "",
      razon_social: "",
      rfc: "",
      regimen: "",
      email: "",
      telefono: [],
      logo: "",
      domicilio: {
        calle: "",
        numero_ext: "",
        numero_int: "",
        colonia: "",
        localidad: "",
        ciudad: "",
        municipio: "",
        estado: "",
        codigo_postal: "",
        referencias: ""
      },
      contacto: {
        nombre: "",
        telefono: "",
        email: ""
      },
      certificado: {
        cer: "",
        key: "",
        password: ""
      },
      serie: "",
      folio: "",
      estatus: "",
      creado: {
        usuario: "",
        fecha: ""
      },
      actualizado: [],
      //impuestos: [],
      //tags: [],
      //tipos_precio: [],
      //pagos: [],
      //registro_fiscal: [],
      parametros: {
        clientes: true,
        proveedores: true,
        productos: true,
        tags: true,
        tipos_precio: true,
        impuestos: true
      },
      total_creditos: 0,
      total_usados: 0,
      prepago:false
    },
    emptymodel: {
      uuid: "",
      nombre: "",
      razon_social: "",
      rfc: "",
      regimen: "",
      email: "",
      telefono: [],
      logo: "",
      domicilio: {
        calle: "",
        numero_ext: "",
        numero_int: "",
        colonia: "",
        localidad: "",
        ciudad: "",
        municipio: "",
        estado: "",
        codigo_postal: "",
        referencias: ""
      },
      contacto: {
        nombre: "",
        telefono: "",
        email: ""
      },
      certificado: {
        cer: "",
        key: "",
        password: ""
      },
      serie: "",
      folio: "",
      estatus: "",
      creado: {
        usuario: "",
        fecha: ""
      },
      actualizado: [],
      //impuestos: [],
      //tags: [],
      //tipos_precio: [],
      pagos: [],
      //registro_fiscal: [],
      parametros: {
        clientes: true,
        proveedores: true,
        productos: true,
        tags: true,
        tipos_precio: true,
        impuestos: true
      },
      prepago:false
    },
    updateModel: false,
    rules: {},
    headers: [{
        text: "Nombre",
        value: "nombre",
      },
      {
        text: "Email",
        value: "email",
      },
      {
        text: "Estatus",
        value: "estatus",
      },
      {
        sortable: false,
        text: "Operaciones",
        value: "actions",
      },
    ],
    columns: ["nombre", "email", "estatus", "contacto.nombre", "total_creditos", "total_usados", "saldo" ,"actions"],
    options: {
      filterable: ["nombre", "email", "estatus", "contacto.nombre"],
      sortable: ["nombre", "email", "estatus", "contacto.nombre"],

      headings: {
        nombre: "Nombre",
        email: "Email",
        estatus: "Estatus",
        "contacto.nombre": "Contacto",
        total_creditos: "Total de Creditos",
        total_usados: "Creditos Utilizados",
        saldo: "Saldo",
        actions: "Operaciones"
      }
    },
    items: [],
    columns_pagos: ["fecha", "importe", "creditos", "actions"],
    options_pagos: {
      filterable: ["fecha", "importe", "creditos"],
      sortable: ["fecha", "importe", "creditos"],

      headings: {
        fecha: "Fecha de Pago",
        importe: "Importe",
        creditos: "Créditos",
        actions: "Operaciones"
      }
    },
    items_pagos: [],
    search: undefined,
  }),
  computed: {
    tituloModal() {
      return this.updateModel === false ? "Nueva Empresa" : "Editar Empresa";
    },
  },
  methods: {
    cargar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      this.$axios.post(this.URL + "list_empresas/")
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.items = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los registros.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    agregar: function() {
      this.model = JSON.parse(JSON.stringify(this.emptymodel));
      this.updateModel = false;
      this.modal = true;
    },
    editar: function(id) {
      this.model = JSON.parse(JSON.stringify(this.emptymodel));
      this.getData(id);
      this.modal = true;
      this.updateModel = true;
    },
    pagos: async function(id) {
      this.clean_model_pagos();
      await this.getData(id);
      this.model_pagos.uuid_empresa = id;
      this.modal_pagos = true;
    },
    guardar_pago: function() {
      if (!this.$refs.form_pagos.validate()) {
        //Alguna operación o mensaje
      } else {
        this.modal_pagos = false;
        this.$root.$dialogLoader.show("Espere un momento por favor..");

        var url = this.URL + "agregar_pago/";
        this.model_pagos.uuid = this.$uuid.v4();

        var self = this;
        this.$axios.post(url, this.model_pagos)
          .then(res => {
            self.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "El registro se guardó correctamente.",
              footer: "",
            });
          })
          .catch(err => {
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al guardar el registro.",
              footer: "",
            });
            console.log(err);
          }).then(() => {
            self.model_pagos.importe = "";
            self.model_pagos.creditos = "";
            self.getData(self.model_pagos.uuid_empresa);
            self.cargar();
            self.$root.$dialogLoader.hide();
            self.modal_pagos = true;
          });

      }
    },
    eliminar_pago: function(id) {
      var self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var params = {
            uuid: id,
            uuid_empresa: self.model_pagos.uuid_empresa
          };
          this.$axios.post(this.URL + "remover_pago/", params)
            .then(res => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se eliminó correctamente.",
                footer: "",
              });
            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al eliminar el registro.",
                footer: "",
              });
              console.log(err);
            }).then(() => {
              self.getData(self.model_pagos.uuid_empresa);
              self.cargar();
              self.$root.$dialogLoader.hide();
            });

        }
      });
    },
    getData: function(id) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      var params = {
        filtros: {
          uuid: id
        }
      };
      this.$axios.post(this.URL + "list_empresas/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.model = res.data[0];
            self.items_pagos = self.model.pagos;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener el registro.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    eliminar: function(id) {
      var self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var params = {
            uuid: id,
          };
          this.$axios.post(this.URL + "delete_empresa/", params)
            .then(res => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se eliminó correctamente.",
                footer: "",
              });
              self.cargar();
            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al eliminar el registro.",
                footer: "",
              });
              console.log(err);
            }).then(() => {
              self.$root.$dialogLoader.hide();
            });

        }
      });

    },
    guardar: function() {
      if (!this.$refs.formempresa.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var actualizado = {
          usuario: this.usuario,
          fecha: moment().format('YYYY-MM-DD HH:mm:ss')
        }
        var url = this.URL + "create_empresa/";
        if (this.updateModel === false) {
          this.model.uuid = this.$uuid.v4();
          this.model.creado = actualizado;
        } else {
          url = this.URL + "update_empresa/";
          this.model.actualizado.push(actualizado);
        }

        var self = this;
        this.$axios.post(url, this.model)
          .then(res => {
            self.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "El registro se guardó correctamente.",
              footer: "",
            });
            self.modal = false;
          })
          .catch(err => {
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al guardar el registro.",
              footer: "",
            });
            console.log(err);
          }).then(() => {
            self.cargar();
            self.$root.$dialogLoader.hide();
          });

      }
    },
    clean_model_pagos: function() {
      this.model_pagos = {
        "uuid": "",
        "importe": "",
        "creditos": "",
        "fecha": "",
        "uuid_empresa": ""
      }
    }
  },
  created: function() {
    this.URL = this.$hostname + "carta_porte/administracion/";
    this.rules = this.$rules;
    this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
    this.cargar();
  }
};
</script>
